import React, { useState, useEffect } from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col } from 'reactstrap';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';

//Api
import tipoDestino_api from '../../../api/tipoDestino_api';

//Helpers
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial do tipo de destion
function initialStateTipo() {
    return {
        tbTipoDestino_Descricao: "",
        status: "Ativo",

    }
}
export default function TipoDestino({ permissao }) {

    //Estado de controle dos dados do tipo de destino
    const [tipo, setTipo] = useState(initialStateTipo);

    //Estado que guarda a lista dos destinos
    const [tipos, setTipos] = useState([])

    //Estado de controle da apresentação do modal na tela
    const [openModal, setOpenModal] = useState(false);

    //Estado que controla o loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros na tela
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do cadastro de tipo de destino
    const campos = [objCampo({ name: "tbTipoDestino_Descricao", required: true })];

    //Controle da apresentação do modal na tela
    const toggleModal = () => {
        if (openModal) {
            setTipo(initialStateTipo);
            setErrors({});
        }
        setOpenModal(!openModal)
    };

    //Carrega a lista dos tipos de destinos
    function loadTipos() {
        setLoading(true);
        tipoDestino_api.GetList().then(response => {
            setTipos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //carrega a lista dos tipos de destinos assim que o componente é inicializado
    useEffect(() => {
        loadTipos();
    }, []);

    //Adiciona/Edita um novo tipo de destino
    const addNovoTipoDestino = () => {

        const erros = validarCampos(tipo, campos);
        setErrors(erros[0]);
        if (erros[1].length) {
            return;
        }

        setLoading(true);

        if (!tipo.id) {
            tipoDestino_api.Post(tipo).then(response => {
                showMessage("Sucesso", "sucesso ao adicionar o novo tipo de destino", "success", null);
                setTipo(initialStateTipo);
                toggleModal();
                loadTipos();
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        } else {
            tipoDestino_api.Put(tipo).then(response => {
                showMessage("Sucesso", "sucesso ao editar o novo tipo de destino", "success", null);
                setTipo(initialStateTipo);
                toggleModal();
                loadTipos();
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
        }
    }

    //Change dos campos do tipo de destino
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        const _tipo = {
            ...tipo,
            [name]: value
        };
        const campo = campos.filter(c => c.name == name);
        const erros = validarCampos(_tipo, campo);
        const _errors = { ...errors };
        if (erros[1].length == 0) {
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ..._errors, ...erros[0] });
        }
        setTipo(_tipo);
    }

    //Opções para o status do tipo de destino
    const optionsStatus = [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
    ]

    //Cabeçalhos da tabela de tipos de destinos
    const headers = [
        { value: "Identificação", objectValue: "tbTipoDestino_Descricao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]

    //Função que é executada no clique do botão editar
    const editar = (item) => {
        setLoading(true);
        tipoDestino_api.GetItem(item.id).then(response => {
            setTipo(response.data);
            setOpenModal(true);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Ações da tabela de tipos de destino
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editar));
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized isOpen={openModal} toggle={toggleModal} title={"Novo tipo de destino"} btnActionColor={tipo.id ? "warning text-light" : "success"} onClickBtnAction={addNovoTipoDestino} btnAction={tipo.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.tbTipoDestino_Descricao ? true : false} maxLength={"100"} label={"* Identificação"} name="tbTipoDestino_Descricao" value={tipo.tbTipoDestino_Descricao} onChange={onChangeTipo} />
                            {errors.tbTipoDestino_Descricao && <span className={"form-control-label text-danger"}>{errors.tbTipoDestino_Descricao.message}</span>}
                        </Col>
                        <Col md="12" lg="6">
                            <TextField label={"Status"} type={"select"} name="status" value={tipo.status} options={optionsStatus} onChange={onChangeTipo} />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem actions={actions} headers={headers} items={tipos} title="Lista de tipos de destino" options={{ print: false, search: true, pagination: true }} />
                </div>
            </MainCard>
        </>
    )
}